import axios from 'axios'
const { mainServer, BASIC_AUTH_HEADER } = require("../../../variables/config");

//gets
export const request_promotionalbanners = async(params) => {
    mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
    const response = await mainServer.get(`/promotionalbanner/list${params}` )
    return response.data.data
}

export const request_promotionalbanner = async(id) => {
    mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
    const response = await mainServer.get(`/promotionalbanner/${id}` )
    return response.data.data
}

export const request_categories = async() => {
    mainServer.defaults.headers.common['Authorization'] = BASIC_AUTH_HEADER
    const response = await mainServer.get(`/category/list` )
    return response.data.data
}

//posts
export const request_create_promotionalbanner = async(data) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.post(`/promotionalbanner`, data)
    return response.data.data
}


//patchs
export const request_update_promotionalbanner = async(id, data) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.patch(`/promotionalbanner/${id}`, data )
    return response.data.data
}

//deletes
export const request_delete_promotionalbanner = async(id) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    const response = await mainServer.delete(`/promotionalbanner/${id}`)
    return response.data.data
}

/*--------MEDIA--------*/
//posts
export const request_upload_promotionalbanner_image = async(id, file, data) => {
    const logData = JSON.parse(localStorage.getItem('token_data'));
    mainServer.defaults.headers.common['Authorization'] = logData.token;
    let response = await mainServer.post(`/promotionalbanner/${id}/image`, data)
    const options = {headers: {'Content-Type': file.type}}
    delete axios.defaults.headers.common["Authorization"]
    await axios.put(response.data.data.upload_url, file, options);
}

//deletes
export const request_delete_image_file = async (id, data) => {
    const credentials = JSON.parse(localStorage.getItem('token_data'))
    mainServer.defaults.headers.common['Authorization'] = credentials.token
    console.log(data)
    let response = await mainServer.delete(`/promotionalbanner/${id}/image/${data}`)
    return response.data.data
}

